import { CURRENCY, PriceOutput } from '@allocab/allocab-commons-shared-types';

import { assertNever } from './common';
import { DriverOptions } from '../services/driver-options/driverOptionsContext';
import { locale, t } from '../services/translation/translation';

export const getCurrencySymbol = (currency: CURRENCY) => {
  switch (currency) {
    case 'EURO':
      return '€';
    case 'DOLLAR':
      return '$';
    case 'YEN':
      return '¥';
    default:
      assertNever(currency, '[getCurrencySymbol] Currency unknown');
      return '';
  }
};

export const formatPrice = (
  amount?: number,
  currency?: CURRENCY,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
) => {
  if (amount === undefined) return '';

  const currencySymbol = currency ? getCurrencySymbol(currency) : '€';

  return `${(amount / 100).toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  })}${currencySymbol}`;
};

export const formatPriceOptions = (driverOptions: DriverOptions) => {
  if (driverOptions.isSubjectToVAT && driverOptions.seePriceWithCommission) return t('price.ttc-brut');
  if (driverOptions.isSubjectToVAT && !driverOptions.seePriceWithCommission) return t('price.ttc-net');
  if (!driverOptions.isSubjectToVAT && driverOptions.seePriceWithCommission) return t('price.ht-brut');
  if (!driverOptions.isSubjectToVAT && !driverOptions.seePriceWithCommission) return t('price.ht-net');

  return '';
};

export const formatPriceByOptions = (
  driverOptions: Pick<DriverOptions, 'isSubjectToVAT' | 'seePriceWithCommission'>,
  buyPrice: PriceOutput,
  netBuyPrice: PriceOutput,
) => {
  if (driverOptions.isSubjectToVAT && driverOptions.seePriceWithCommission)
    return formatPrice(buyPrice.amountWithTax, buyPrice.currency);
  if (driverOptions.isSubjectToVAT && !driverOptions.seePriceWithCommission)
    return formatPrice(netBuyPrice.amountWithTax, netBuyPrice.currency);
  if (!driverOptions.isSubjectToVAT && driverOptions.seePriceWithCommission)
    return formatPrice(buyPrice.amount, buyPrice.currency);
  if (!driverOptions.isSubjectToVAT && !driverOptions.seePriceWithCommission)
    return formatPrice(netBuyPrice.amount, netBuyPrice.currency);

  return '';
};
